import React from "react"
import { Link } from "gatsby"
import Logo from "../components/Logo"

import "./NavigationBar.scss"

const IconMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="17.6" viewBox="0 0 26 17.6">
    <path d="M1.6,17.6a1.6,1.6,0,1,1,0-3.2H24.4a1.6,1.6,0,1,1,0,3.2Zm0-7.2a1.6,1.6,0,1,1,0-3.2H24.4a1.6,1.6,0,1,1,0,3.2Zm0-7.2A1.6,1.6,0,0,1,1.6,0H24.4a1.6,1.6,0,1,1,0,3.2Z" />
  </svg>
)
const IconClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19.322" height="19.322" viewBox="0 0 19.322 19.322">
    <path d="M23.254,17.116l-6.93-6.93-6.93,6.93a1.6,1.6,0,0,1-2.263-2.263l6.93-6.93L7.132.994a1.6,1.6,0,0,1,0-2.263,1.6,1.6,0,0,1,2.263,0l6.93,6.93,6.93-6.93a1.6,1.6,0,0,1,2.263,0,1.6,1.6,0,0,1,0,2.263l-6.93,6.93,6.93,6.93a1.6,1.6,0,0,1-2.263,2.263Z" transform="translate(-6.663 1.737)" />
  </svg>
)

const ButtonsCTA = ({ openLangSelector, langSelectorIsOpen }) => (
  <div className="cta">
    <Link to="/support"><span className="support">Soporte</span></Link>
    <Link to="/contact"><span className="button actionmaker">Contáctanos</span></Link>
    <button title="Seleccionar idioma" aria-label="Seleccionar idioma" className={["lang-selector", langSelectorIsOpen ? 'active' : null].join(' ')} onClick={openLangSelector}>
      <span className="flag mx"></span>
      <span className="arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7.303" viewBox="0 0 13 7.303">
          <path d="M16,5.5,10.7,11ZM10.7,0,16,5.5Z" transform="translate(12 -9.697) rotate(90)" />
        </svg>
      </span>
    </button>
    {
      langSelectorIsOpen ? (
        <div className="lang-list">
          <a href="https://derevo.com.mx">
            <span className="flag mx"></span>
            <span>Español</span>
          </a>
          <a href="https://derevo.us">
            <span className="flag usa"></span>
            <span>Inglés</span>
          </a>
        </div>
      ) : null
    }
  </div>
)

const PageList = ({ activePage }) => {
  let navigation = [
    { id: 'services', link: '/data-analytics', text: 'Soluciones' },
    { id: 'technologies', link: '/powerbi', text: 'Tecnologías' },
    { id: 'success', link: '/success', text: 'Success' },
    { id: 'courses', link: '/courses/power-bi', text: 'Cursos' },
    { id: 'aboutus', link: '/aboutus', text: 'Nosotros' },
    { id: 'careers', link: '/careers', text: 'Careers' },
    { id: 'blog', link: '/blog', text: 'Blog' }
  ]

  return (
    <div className="navigation">
      <ul>
        {
          navigation.map(i => (
            <li key={i.id} className={(activePage === i.id) ? 'active' : ''}>
              <Link to={i.link}>{i.text}</Link>
            </li>
          ))
        }
      </ul>
    </div>
  )
}

class NavigationBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activePage: this.props.activePage ? this.props.activePage : null,
      isMobile: false,
      navMobileIsOpen: false,
      langSelectorIsOpen: false,
      navTheme: this.props.theme ? ` ${this.props.theme}` : null,
      customTheme: this.props.customTheme ? this.props.customTheme : null,
      sectionActive: 0,
      sectionPositions: []
    }

    this.handleResizeListener = this.handleResizeListener.bind(this)
    this.handleScrollListener = this.handleScrollListener.bind(this)
    this.handleOpenNavMobile = this.handleOpenNavMobile.bind(this)
    this.handleOpenLangSelector = this.handleOpenLangSelector.bind(this)
  }
  componentDidMount() {
    let { customTheme } = this.state
    let sectionPositions = []

    if (customTheme !== null) {
      sectionPositions = customTheme.map(i => document.getElementById(i.id).offsetTop)
    }

    this.setState({
      isMobile: !(window.innerWidth > 1079),
      sectionPositions: sectionPositions
    })

    window.addEventListener('resize', this.handleResizeListener)
    if (customTheme !== null) { window.addEventListener('scroll', this.handleScrollListener) }
  }
  componentWillUnmount() {
    let { customTheme } = this.state

    window.removeEventListener('resize', this.handleResizeListener)
    if (customTheme !== null) { window.removeEventListener('scroll', this.handleScrollListener) }
  }
  handleResizeListener(evt) {
    let { isMobile } = this.state
    let condition = !(window.innerWidth > 1079)

    if (isMobile !== condition) {
      this.setState({ isMobile: condition })
    }
  }
  handleScrollListener(evt) {
    let { customTheme, sectionActive, sectionPositions } = this.state
    let sectionActiveList = []

    sectionPositions.forEach((el, i) => {
      if (window.scrollY >= (el - 128)) {
        sectionActiveList.push(i)
      }
    })

    if (sectionActiveList.length > 0) {
      let auxSectionActive = sectionActiveList[sectionActiveList.length - 1]

      if (sectionActive !== auxSectionActive) {
        this.setState({
          sectionActive: auxSectionActive,
          navTheme: customTheme[auxSectionActive].theme ? ` ${customTheme[auxSectionActive].theme}` : null
        })
      }
    }
  }
  handleOpenNavMobile() {
    let navMobileIsOpen = !this.state.navMobileIsOpen
    this.setState({ navMobileIsOpen: navMobileIsOpen })
  }
  handleOpenLangSelector() {
    let langSelectorIsOpen = !this.state.langSelectorIsOpen
    this.setState({ langSelectorIsOpen: langSelectorIsOpen })
  }
  render() {
    let { activePage, isMobile, navMobileIsOpen, langSelectorIsOpen, navTheme } = this.state

    return (
      <nav className={['navigation-bar', (isMobile ? ' mobile' : null), (navMobileIsOpen ? ' open' : null), navTheme].join('')}>
        <div className="content">
          <div className="logo">
            <Link to="/" aria-label="Volver a la página principal">
              <Logo />
            </Link>
          </div>
          {
            !isMobile ?
              <PageList activePage={activePage} />
              : null
          }
          {
            !isMobile ? (
              <ButtonsCTA openLangSelector={this.handleOpenLangSelector} langSelectorIsOpen={langSelectorIsOpen} />
            ) : (
              <div className="cta">
                <button className="menu" onClick={this.handleOpenNavMobile}>
                  {navMobileIsOpen ? <IconClose /> : <IconMenu />}
                </button>
              </div>
            )
          }
        </div>
        {
          isMobile ? (
            <div className="navigation mobile">
              <PageList activePage={activePage} />
              <div className="navigation-mobile-buttons">
                <ButtonsCTA openLangSelector={this.handleOpenLangSelector} langSelectorIsOpen={langSelectorIsOpen} />
              </div>
            </div>
          ) : null
        }
      </nav>
    )
  }
}

export default NavigationBar